<template>
  <div id="SmartTaskForm" class="">
    <div class="row d-flex justify-content-end no-gutters">
      <b-button
        class="goal-button mt-3 d-flex align-items-center"
        @click="visible = !visible"
        ><i class="fas fa-plus-circle fa-2x mr-2"></i
        ><span>Set a Smart Goal</span></b-button
      >
    </div>
    <b-collapse v-model="visible">
      <div class="smart-goal-container">
        <div class="smart-goal-top">
          <div class="d-flex flex-column">
            <div class="mb-1 ml-2">Title</div>
            <input
              class="smart-goal-date-input mr-2"
              type="text"
              placeholder="Add a title here..."
              v-model="smartTaskTitle"
            />
          </div>
          <div class="d-flex flex-column">
            <div class="mb-1 ml-2">Target Date</div>
            <input
              class="smart-goal-date-input"
              type="date"
              v-model="smartTaskDate"
            />
          </div>
        </div>
        <div class="mt-2">
          <div class="mb-1 ml-2">Description</div>
          <textarea
            class="smart-goal-text-input w-100"
            placeholder="Provide a description..."
            maxlength="150"
            id="smart-goal-text"
            v-model="smartTaskContent"
          />
        </div>
        <div class="d-flex flex-row justify-content-end">
          <b>150 character limit</b>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end mt-3">
        <b-button
          class="goal-button"
          @click="createSmartTask()"
          :disabled="!smartTaskContent || !smartTaskTitle"
          >Add Smart Goal</b-button
        >
      </div>
    </b-collapse>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/config/constants";
import EventBus from "@/helpers/eventbus";

export default {
  name: "SmartTask",
  props: ["goalId", "milestoneId"],
  data() {
    return {
      smartTaskTitle: "",
      smartTaskDate: "",
      smartTaskContent: "",
      visible: false,
      isCreateTaskLoading: false
    };
  },
  mounted() {
    this.smartTaskDate = moment().format("YYYY-MM-DD");
  },
  methods: {
    async createSmartTask() {
      if (this.isCreateTaskLoading) return
      try {
        this.isCreateTaskLoading = true
        const payload = {
          user_id: this.$store.getters.user_id,
          milestone_id: this.milestoneId,
          goal_id: this.goalId,
          title: this.smartTaskTitle,
          content: btoa(this.smartTaskContent)
        };
        let res = await this.axios.post(
          process.env.VUE_APP_API_PATH +
            "/application/api/u/coaching/create-task",
          payload,
          config.options
        );
        if (res.data.success) {
          Object.assign(this.$data, this.$options.data.apply(this));
          this.smartTaskDate = moment().format("YYYY-MM-DD");
          EventBus.$emit("getCoachingData");
        }
      } catch(err) {
        console.error(err)
      } finally {
        this.isCreateTaskLoading = false
      }
    }
  }
};
</script>

<style lang="less">
#SmartTaskForm {
  .smart-goal-container {
    background-color: white;
    border-radius: 10px;
    padding: 10px;
    margin-top: 10px;
    .smart-goal-top {
      display: flex;
      gap: 4px;
      justify-content: space-between;
    }
    .smart-goal-date-input {
      outline: none !important;
      border: 2px #f3f3f3 solid !important;
      border-radius: 10px;
      padding: 5px;
    }
    .smart-goal-text-input {
      outline: none !important;
      border: 2px #f3f3f3 solid !important;
      border-radius: 10px;
      padding: 5px;
    }
  }
  .goal-button {
    letter-spacing: 0;
    font-size: 1.4rem;
    min-height: 44px;
    background-color: #ed3a75;
    color: #fff;
    &:hover {
      background-color: #ed3a76d9;
    }
  }
  @media only screen and (max-width: 576px) {
    .smart-goal-top {
      flex-direction: column-reverse;
      gap: 8px;
    }
  }
}
</style>
